import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import StatePage from './pages/StatePage';
import VpobApobPage from './pages/VpobApobPage';
import StartupCompliancePage from './pages/StartupCompliancePage';
import StartupServicePage from './pages/StartupServicePage';
import GstAdvisoryPage from './pages/GstAdvisoryPage';
import EcomAccountingPage from './pages/EcomAccountingPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import BlogEditorPage from './pages/BlogEditorPage';
import AuthCallback from './pages/AuthCallback';

// CRITICAL: Detect session_id in URL fragment synchronously during render (not in useEffect).
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/vpob-apob" element={<VpobApobPage />} />
      <Route path="/startup-and-compliance" element={<StartupCompliancePage />} />
      <Route path="/startup-and-compliance/:subslug" element={<StartupServicePage />} />
      <Route path="/gst-advisory" element={<GstAdvisoryPage />} />
      <Route path="/ecommerce-accounting" element={<EcomAccountingPage />} />
      <Route path="/contact-us" element={<ContactPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-of-service" element={<TermsOfServicePage />} />
      <Route path="/refund-policy" element={<RefundPolicyPage />} />
      <Route path="/virtual-office-in/:slug" element={<StatePage />} />
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/blogs/new" element={<ProtectedRoute><BlogEditorPage /></ProtectedRoute>} />
      <Route path="/admin/blogs/:id/edit" element={<ProtectedRoute><BlogEditorPage /></ProtectedRoute>} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
